import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;

  min-height: 100%;
  min-width: 100%;
`;
